/**
 * Казахстанский телефон: одна каноническая форма 7XXXXXXXXXX.
 * «8 701…», «+7 701…», «701…» — один и тот же гость, а не три.
 */
export function normalizePhoneKz(raw: string): string | null {
  const digits = raw.replace(/\D/g, '');
  const canon =
    digits.length === 11 && digits.startsWith('8') ? `7${digits.slice(1)}`
    : digits.length === 11 && digits.startsWith('7') ? digits
    : digits.length === 10 && digits.startsWith('7') ? `7${digits}`
    : null;
  return canon;
}

export function formatPhoneKz(canon: string): string {
  if (canon.length !== 11) return canon;
  return `+7 ${canon.slice(1, 4)} ${canon.slice(4, 7)}-${canon.slice(7, 9)}-${canon.slice(9)}`;
}
